export const logout = () => {
    localStorage.removeItem("__data");
    window.location.href = "/";
};
